<template>
  <div class="gx-ss">
    <h1 class="gx-main__title">桌面端&插件端下载入口</h1>

    <!-- 授权卡（通用） -->
    <div class="gx-ss__card">
      <div class="gx-ss__banner gx-ss__banner--red">
        <div class="gx-ss__banner-icon">{{ authCard.icon || '🔑' }}</div>
        <div>
          <div class="gx-ss__banner-title">{{ authCard.title }}</div>
          <div class="gx-ss__banner-sub">{{ authCard.subtitle }}</div>
        </div>
      </div>
      <div class="gx-ss__body">
        <div class="gx-ss__row">
          <div>
            <div class="gx-ss__name">{{ authCard.label }}</div>
            <div class="gx-ss__desc">{{ authCard.description }}</div>
          </div>
          <div class="gx-ss__actions">
            <span v-if="copied" class="gx-ss__copied">已复制</span>
            <button class="gx-ss__btn-red" :disabled="codeLoading" @click="getAuthCode">
              {{ codeLoading ? '获取中...' : '🔑 获取授权 code' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 桌面端 -->
    <div class="gx-ss__card">
      <div class="gx-ss__banner gx-ss__banner--red">
        <div class="gx-ss__banner-icon">💻</div>
        <div>
          <div class="gx-ss__banner-title">{{ desktopGroup.name }}</div>
          <div class="gx-ss__banner-sub">{{ desktopGroup.subtitle }}</div>
        </div>
      </div>
      <div class="gx-ss__body">
        <div
          v-for="item in desktopGroup.items"
          :key="item.tool_key"
          class="gx-ss__row"
        >
          <div>
            <div class="gx-ss__name">{{ item.display_name }}</div>
            <div class="gx-ss__desc">{{ item.meta || item.description || '' }}</div>
          </div>
          <button v-if="item.download_url" class="gx-ss__download" @click="openToolDownload(item)">
            ↓ {{ item.button_text || '下载软件' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 浏览器插件 -->
    <div class="gx-ss__card">
      <div class="gx-ss__banner gx-ss__banner--blue">
        <div class="gx-ss__banner-icon">🧩</div>
        <div>
          <div class="gx-ss__banner-title">{{ pluginGroup.name }}</div>
          <div class="gx-ss__banner-sub">{{ pluginGroup.subtitle }}</div>
        </div>
      </div>
      <div class="gx-ss__body">
        <div
          v-for="item in pluginGroup.items"
          :key="item.tool_key"
          class="gx-ss__row"
        >
          <div>
            <div class="gx-ss__name">{{ item.display_name }}</div>
            <div class="gx-ss__desc">{{ item.meta || item.description || '' }}</div>
          </div>
          <button v-if="item.download_url" class="gx-ss__download" @click="openToolDownload(item)">
            ↓ {{ item.button_text || '下载软件' }}
          </button>
        </div>
        <div v-if="pluginGroup.tips" class="gx-ss__notice">
          <div class="gx-ss__notice-text">{{ pluginGroup.tips }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getSystemToolDownloads } from '../../api/main/ucenter'

export default {
  name: 'NewSystemSoftwarePage',
  data() {
    return {
      toolGroups: [],
      toolDownloadUrls: {
        desktop_client: '',
        ops_plugin: '',
        sku_plugin: ''
      },
      codeLoading: false,
      copied: false,
      authCode: '',
      authCard: {
        title: '桌面端 / 插件授权',
        subtitle: '获取授权码，激活桌面客户端与浏览器插件（通用）',
        label: '通用授权码',
        description: '授权码同时适用于观星树桌面客户端、运营插件、星好货SKU插件。',
        icon: '🔑'
      }
    }
  },
  computed: {
    desktopGroup() {
      const group = (this.toolGroups || []).find((g) => g.code === 'desktop')
      return group || {
        code: 'desktop',
        name: '观星树桌面客户端',
        subtitle: '提供更流畅的操作体验和更多桌面专属功能',
        tips: null,
        items: [{
          tool_key: 'desktop_client',
          display_name: '桌面端下载',
          meta: 'Windows 10/11 · 64位 · 当前版本 v2.3.1',
          description: null,
          button_text: '下载软件',
          download_url: this.toolDownloadUrls.desktop_client
        }]
      }
    },
    pluginGroup() {
      const group = (this.toolGroups || []).find((g) => g.code === 'browser_plugin')
      return group || {
        code: 'browser_plugin',
        name: '观星树浏览器插件',
        subtitle: 'Chrome/Edge 扩展程序，实现一键铺货和数据同步',
        tips: '插件支持 Chrome 88+ 和 Edge 88+。安装后在插件管理页启用，并登录您的观星树账号绑定使用。授权码为桌面端与插件通用。',
        items: [
          {
            tool_key: 'ops_plugin',
            display_name: '观星树运营插件',
            meta: null,
            description: '下载插件安装包',
            button_text: '下载软件',
            download_url: this.toolDownloadUrls.ops_plugin
          },
          {
            tool_key: 'sku_plugin',
            display_name: '星好货SKU插件',
            meta: null,
            description: '下载插件安装包',
            button_text: '下载软件',
            download_url: this.toolDownloadUrls.sku_plugin
          }
        ]
      }
    }
  },
  created() {
    this.loadSystemToolDownloads()
  },
  methods: {
    ...mapActions({
      getGenerateCheckCode: 'ucenter/getGenerateCheckCode'
    }),
    loadSystemToolDownloads() {
      getSystemToolDownloads({}).then((res) => {
        if (res.code === 200 && res.data) {
          const data = res.data
          if (Array.isArray(data.groups)) {
            this.toolGroups = data.groups
          }
          if (data.auth && typeof data.auth === 'object') {
            this.authCard = {
              title: data.auth.title || this.authCard.title,
              subtitle: data.auth.subtitle || this.authCard.subtitle,
              label: data.auth.label || this.authCard.label,
              description: data.auth.description || this.authCard.description,
              icon: data.auth.icon || this.authCard.icon
            }
          }
          const downloads = data.downloads && typeof data.downloads === 'object'
            ? data.downloads
            : (typeof data === 'object' ? data : {})
          Object.keys(this.toolDownloadUrls).forEach((toolKey) => {
            const downloadUrl = downloads[toolKey]
            if (typeof downloadUrl === 'string' && downloadUrl.trim()) {
              this.toolDownloadUrls[toolKey] = downloadUrl
            }
          })
        }
      }).catch(() => {})
    },
    getAuthCode() {
      if (this.codeLoading) return
      this.codeLoading = true
      this.getGenerateCheckCode({
        data: {},
        success: (res) => {
          this.codeLoading = false
          if (res.code === 200) {
            this.authCode = res.data && res.data.code != null ? String(res.data.code) : ''
            if (!this.authCode) {
              this.$message.error('授权码为空')
              return
            }
            this.copyToClipboard(this.authCode)
            this.$message.success('授权码已复制')
          } else {
            this.$message.error(res.msg || res.message || '获取授权码失败')
          }
        }
      })
    },
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch(() => { this.copyFallback(text) })
      } else {
        this.copyFallback(text)
      }
      this.copied = true
      setTimeout(() => { this.copied = false }, 2500)
    },
    copyFallback(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
    },
    openToolDownload(item) {
      const url = (item && item.download_url)
        || this.toolDownloadUrls[item && item.tool_key]
        || ''
      if (!url) {
        this.$message.error('下载地址未配置')
        return
      }
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.gx-main__title {
  margin: 0 0 16px;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
}
.gx-ss {
  padding: 8px 4px 24px;
}
.gx-ss__card {
  max-width: 30%;
  min-width: 600px;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(26, 26, 46, 0.06);
  margin-bottom: 16px;
}
.gx-ss__banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  color: #fff;
}
.gx-ss__banner--red {
  background: linear-gradient(135deg, #ff6b5a 0%, #e85d4c 100%);
}
.gx-ss__banner--blue {
  background: linear-gradient(135deg, #4c8dff 0%, #3a73e0 100%);
}
.gx-ss__banner-icon {
  font-size: 28px;
  line-height: 1;
}
.gx-ss__banner-title {
  font-size: 16px;
  font-weight: 700;
}
.gx-ss__banner-sub {
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.92;
}
.gx-ss__body {
  padding: 14px 16px 16px;
}
.gx-ss__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 14px;
  border: 1px solid #eef0f5;
  border-radius: 10px;
  background: #fafbfe;
}
.gx-ss__row + .gx-ss__row {
  margin-top: 10px;
}
.gx-ss__name {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
}
.gx-ss__desc {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
}
.gx-ss__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.gx-ss__copied {
  font-size: 12px;
  color: #52c41a;
}
.gx-ss__btn-red,
.gx-ss__download {
  border: none;
  border-radius: 8px;
  padding: 9px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.gx-ss__btn-red {
  background: #fa5757;
  color: #fff;
}
.gx-ss__btn-red:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.gx-ss__download {
  background: #fff;
  color: #1a1a2e;
  border: 1px solid #d8dde8;
}
.gx-ss__download:hover {
  border-color: #fa5757;
  color: #fa5757;
}
.gx-ss__notice {
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #eef5ff;
  color: #2f5fbf;
  font-size: 12px;
  line-height: 1.6;
}
</style>
